import { render, staticRenderFns } from "./MonthAllowancesPlanAdd.vue?vue&type=template&id=30df801c&scoped=true&"
import script from "./MonthAllowancesPlanAdd.vue?vue&type=script&lang=js&"
export * from "./MonthAllowancesPlanAdd.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "30df801c",
  null
  
)

export default component.exports